import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getInsightColorTrellis } from 'messaging-publishing-lib/Insights/utils';
import { useInsightPolarity } from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useInsightPolarity';
import { TInsightIcon } from 'messaging-publishing-lib/Insights/components/EmailInsights/InsightIcon';
import { getCustomTabId } from 'framework-asset-preview-lib/utils/tabs';
import { INSIGHTS_PANEL_KEY } from 'messaging-publishing-lib/Insights/constant/EmailInsightsPanel';
import { openEmailDetailsPanel } from 'email-management-lib/refactor/actions/manage/frameworkTable';
import { trackInsightsRateClickInteraction } from 'messaging-publishing-lib/utils/tracking';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function withInsightPolarity(WrappedComponent) {
  const ComponentWithInsightPolarity = props => {
    const dispatch = useDispatch();
    const crmObject = useMemo(() => props.crmObject, [props]);
    const aiInsightsTab = getCustomTabId(INSIGHTS_PANEL_KEY);
    const {
      propertyName
    } = props;
    const onClick = useCallback(() => {
      trackInsightsRateClickInteraction(crmObject, propertyName);
      dispatch(openEmailDetailsPanel({
        crmObject,
        tab: aiInsightsTab
      }));
    }, [dispatch, crmObject, aiInsightsTab, propertyName]);
    const maybeInsightPolarity = useInsightPolarity({
      crmObject: props.crmObject,
      propertyName
    });
    if (maybeInsightPolarity !== null) {
      const color = getInsightColorTrellis(maybeInsightPolarity);
      return /*#__PURE__*/_jsx(Link, {
        use: "unstyled",
        onClick: onClick,
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "span",
            typography: "body-125",
            color: color,
            children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
          }), /*#__PURE__*/_jsx(TInsightIcon, {
            marginBlockStart: "50",
            polarity: maybeInsightPolarity
          })]
        })
      });
    }
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };
  return ComponentWithInsightPolarity;
}
export default withInsightPolarity;